import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsersTable from "../components/UsersTable";
import { ToastContainer } from 'react-toastify';

const UsersAllPage = () => {
  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Tüm Kullanıcılar" />
      <UsersTable role="all" title="Tüm Kullanıcılar" />
    </MasterLayout>
  );
};

export default UsersAllPage;

